import React from 'react';
import './How.css';

import logisticsImage from '../../assets/30930.jpg';
import { TfiPackage } from "react-icons/tfi";


const steps = [
    {
        step: 'Step 1',
        title: 'Supplier Onboarding',
        desc: 'We begin by sourcing high-quality raw materials or finished goods from trusted suppliers who meet strict quality and compliance standards.',
    },
    {
        step: 'Step 2',
        title: 'Manufacturing Support',
        desc: 'Our logistics services support manufacturers with timely delivery of components and raw materials, ensuring uninterrupted production cycles.',
    },
    {
        step: 'Step 3',
        title: 'Wholesale Distribution',
        desc: 'Bulk inventory is managed and distributed through our warehousing and transportation network, optimized for scale and efficiency.',
    },
    {
        step: 'Step 4',
        title: 'Retail Fulfillment',
        desc: 'Products are dispatched to retailers across regions with just-in-time inventory and last-mile delivery capabilities.',
    },
];

const HowItWorks = () => {
    return (
        <section className="how-it-works">
            <div className="top-section">
                <img src={logisticsImage} alt="Logistics Process" className="how-img" />
                <div className="text-content">
                    <h5 className="sub-heading">HOW IT WORKS</h5>
                    <h2 className="main-heading">STREAMLINING YOUR SUPPLY CHAIN – END TO END</h2>
                    <p className="description">
                        At Vedant Enterprise, we manage every stage of the supply chain with precision — from sourcing to delivery. Our integrated logistics approach ensures timely flow of goods between suppliers, manufacturers, wholesalers, and retailers, backed by real-time tracking and inventory systems.
                    </p>
                </div>
            </div>

            <hr className="dotted-divider" />

            <div className="steps-section">
                {steps.map((item, idx) => (
                    <div className="step-card" key={idx}>
                        <div className="step-label">{item.step}</div>
                        <div className="icon-wrapper">
                            <TfiPackage />
                        </div>
                        <h4 className="step-title">{item.title}</h4>
                        <p className="step-desc">{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HowItWorks;
